<template>
  <section class="show-img" :style="{width:config.width,height:config.height}">
    <div
      class="show-image"
      :style="{backgroundImage:`url(${config.img})`,backgroundSize:'cover',backgroundPosition: 'center'}"
    ></div>
    <img class="loading" v-if="loading" src="/static/loading.gif" alt />
    <div class="scale">
      <div class="button-list">
        <el-button type="primary" @click="submit">{{$t('global.保存')}}</el-button>
        <el-button @click="cancel">{{$t('global.取消')}}</el-button>
      </div>
    </div>
  </section>
</template>

<script>
import * as qiniu from "qiniu-js";
export default {
  name: "ShowImg",
  props: { config: Object },
  components: {},
  data() {
    return {
      loading: false
    };
  },
  beforeDestroy() {
    this.loading = false;
  },
  methods: {
    getImg(file) {
      if (this.config.minWidth && this.config.minHeight) {
        this.$jsonUtils.checkImageSize(
          {},
          file,
          Number(this.config.minWidth),
          Number(this.config.minHeight),
          data => {
            if (data.state) {
              var reader = new FileReader();
              reader.readAsDataURL(file);
              reader.onload = e => {
                this.config.img = e.target.result;
              };
            } else {
              this.$emit("cancel");
              this.$message.info(
                this.$t("global.文件大小不能小于") +
                  this.config.minWidth +
                  " * " +
                  this.config.minHeight
              );
            }
          }
        );
      } else {
        if (file.type === "image/gif") {
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = e => {
            // this.$emit("update-img", { data: e.target.result });
          };
        } else {
          var reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = e => {
            this.config.img = e.target.result;
          };
        }
      }
    },
    cancel() {
      this.$emit("cancel");
    },
    submit() {
      // let imgFile = this.$jsonUtils.base64ToFile(this.config.img, "a.png");
      this.updateImage(this.config.img);
    },
    updateImage(img) {
      let $this = this;
      this.loading = true;
      let imgFile = this.$jsonUtils.base64ToFile(img, "a.png");
      var observable;
      var subscription;
      var error = function (err) {
        $this.uploadMessage = $this.$t("global.上传失败");
      };
      var complete = function (res) {
        $this.uploadMessage = $this.$t("global.上传成功");
        $this.$emit("submit", res.key);
      };

      var next = function (response) {};

      var subObject = {
        next: next,
        error: error,
        complete: complete,
      };

      var config = {
        useCdnDomain: true,
        region: null,
        domain: "https://image.manamana.net",
        forceDirect: true,
      };
      var putExtra = {
        fname: imgFile.name,
        params: {},
        mimeType: null,
      };
      this.$http.get("/api/common/upload/image/token").then((res) => {
        observable = qiniu.upload(
          imgFile,
          Date.parse(new Date()) + "_" + this.$jsonUtils.randomLetter(8),
          res.message,
          putExtra,
          config
        );
        subscription = observable.subscribe(subObject);
      });
      // let param = new FormData();
      // param.append("files", img);
      // param.append("fileNames", "thumb");
      // this._$http
      //   .post("/api/common/upload/images", param, {
      //     headers: {
      //       "Content-Type": "multipart/form-data"
      //     }
      //   })
      //   .then(res => {
      //     if (res.code === "OK") {
      //       this.$emit("submit", res.data.thumb.key);
      //     }
      //   });
    }
  }
};
</script>

<style lang="stylus" scoped>
.show-img {
  position: relative;

  .show-image {
    width: 100%;
    height: 100%;
  }

  .loading {
    position: absolute;
    bottom: 100px;
    width: 50px;
    height: 50px;
    left: 695px;
    z-index: 2;
  }

  .scale {
    position: absolute;
    bottom: 20px;
    left: calc(50% - 128px);
    width: 256px;

    .button-list {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      .el-button {
        padding: 0 46px;
        width: 120px;
        height: 30px;
        border: 1px solid rgba(255, 255, 255, 0.8);
        border-radius: 0;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #fff;

        &.el-button--primary {
          background: #2026CC;
          opacity: 0.8;
        }

        &.el-button--default {
          background: #0A0A0A;
          opacity: 0.8;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v2/ShowImage.vue